import { device } from "@/utils/devices-screens";
import { styled } from "styled-components";

export const ProductCard = styled.div`
  background-color: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px -2px,
    rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-width: 250px;
  max-width: 450px;
  height: 405px;

  @media ${device.tablet} {
    width: 100%;
  }
`;

export const ProductImage = styled.img`
  display: block;
`;

export const ProductCardContent = styled.div`
  padding: 16px;
  height: 100%;
`;

export const ProductCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ProductTitle = styled.div`
  font-weight: 400;
  line-height: 21px;
  display: inline-block;

  direction: ltr;
  color: var(--text-theme);

  h3 {
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ProductPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ProductPriceCurrentContainer = styled.h3`
  display: flex;
  align-items: center;
  
  p {
    line-height: 22px;
    text-align: center;
    color: var(--text-theme);
  }
  
  p:nth-child(1) {
    margin-right: 5px;
    font-weight: 400;
    text-align: right;
  }

  p:nth-child(2) {
    font-weight: 700;
    font-size: 22px;
  }
`;

export const ProductPricePreviousContainer = styled.div`
  display: flex;
  align-items: center;
  
  p {  
    font-weight: 400;
    text-align: right;
    color: var(--text-theme);
    font-size: 14px;
  }
  
  p:nth-child(1) {
    margin-right: 5px;  
  }
  
  p:nth-child(2) {
    text-decoration: line-through;
  }
`;

export const ProductCardDescription = styled.div`
  margin-top: 15px;

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    margin: 16px 0;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--text-theme);
  }
`;

export const ProductCardMoreInfo = styled.div`
  margin-top: 10px;

  button {
    display: flex;
    color: #3581de;
    font-size: 12px;
    align-items: center;
    cursor: pointer;
    border: none;
    background-color: #fff;
  }

  span {
    color: #3581de;
  }
`;

export const ProductCardFooter = styled.div`
  padding: 16px;
`;

export const ProductBuyNow = styled.button`
  background: #2dace3;
  color: #fff;
  border: 2px solid #2dace3;
  padding: 15px 50px 16px;
  width: 100%;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #2980b9;
    border-color: #2980b9;
  }

  &:active {
    transform: scale(0.98);
  }
`;